import React from "react";

const DashboardContainer = ({ children }) => {
  return <div className="grid grid-cols-1 gap-6">{children}</div>;
};

export default DashboardContainer;